/**
 * LocalStorage key constants
 * Centralizes all localStorage keys used across the application
 */

// Authentication tokens
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

// User information
export const USERNAME_KEY = 'username';
export const NAME_KEY = 'name';
export const DOMAIN_KEY = 'domain';

// Organization and subscription
export const SUBSCRIPTION_TYPE_KEY = 'subscription_type';

// SSO related
export const AUTH_TYPE_KEY = 'auth_type';
export const SSO_IDP_LOGIN_URL_KEY = 'sso_idp_login_url';
